import __request__ from "routing/request";
export function terminateSession() {
  return __request__("DELETE", "/system/sessions", null, {}, {
    "Accept": ["application/json"]
  });
}
export function newSession(Loginrequest) {
  return __request__("POST", "/system/sessions", Loginrequest, {}, {
    "Accept": ["application/json"]
  });
}
export function validateSession() {
  return __request__("GET", "/system/sessions", null, {}, {
    "Accept": ["application/json"]
  });
}
export function terminateSessionWithId(sessionId) {
  return __request__("DELETE", `/system/sessions/${sessionId}`, null, {}, {
    "Accept": ["application/json"]
  });
}
